import { Component } from '@angular/core';
import {HttpClient } from '@angular/common/http'; 
import { AuthService } from '../../_services'; 

@Component({
  selector: 'Hrms',
  templateUrl: './hrms.component.html',  
})

 export class HrmsComponent { 
  constructor(private HttpClient : HttpClient,private auth : AuthService) { 
  }  
  ngOnInit() 
  { 
     
  }

}
 


// WEBPACK FOOTER //
// ./src/app/admin/hrms/hrms.component.ts